import React from 'react';
import { createComponent } from '@workday/canvas-kit-react/common';
import { SystemIcon } from '@workday/canvas-kit-react/icon';
const iconSizes = {
    extraSmall: 18,
    small: 20,
    medium: 20,
    large: 24,
};
export const ButtonLabelIcon = createComponent('span')({
    displayName: 'ButtonLabelIconNew',
    Component: ({ icon, size = 'medium', shouldMirrorIcon = false, ...elemProps }, ref, Element) => {
        if (icon === undefined) {
            return null;
        }
        const iconSize = iconSizes[size];
        return (React.createElement(SystemIcon, Object.assign({ size: iconSize, icon: icon, shouldMirror: shouldMirrorIcon, width: size ? iconSizes[size] : iconSizes.large, height: size ? iconSizes[size] : iconSizes.large, display: "inline-block" }, elemProps)));
    },
});
